import React, { useCallback, useMemo, useState } from 'react';
import VibeScreen from './components/vibe-screen';
import { SohoVibeContext } from './context';

const SohoVibeFlowWrapper = ({
  children,
  enabled = true,
  onComplete = null
}) => {
  const [flowCompleted, setFlowCompleted] = useState(() => !enabled);
  const [isReviewRequested, setIsReviewRequested] = useState(false);

  const completeFlow = useCallback(
    ({ toReview = false } = {}) => {
      if (onComplete) onComplete();
      setIsReviewRequested(toReview);
      setFlowCompleted(true);
    },
    [onComplete]
  );

  const contextValue = useMemo(
    () => ({ isReviewRequested }),
    [isReviewRequested]
  );

  if (flowCompleted) {
    return (
      <SohoVibeContext.Provider value={contextValue}>
        {children}
      </SohoVibeContext.Provider>
    );
  }

  return <VibeScreen onComplete={completeFlow} />;
};

export default SohoVibeFlowWrapper;
